// label → color for bbox overlays. Mirrors the inline palette used in
// scratch/manual-app/embeds/parse-validator/index.html. Stable across all
// consumers so an overlay tagged "Table" looks the same everywhere.

import { Effect } from 'effect';

const PALETTE: Record<string, string> = {
  Table: '#1e60a8',
  Picture: '#6020a0',
  'Section-header': '#a04040',
  'Page-header': '#806020',
  'Page-footer': '#806020',
  Title: '#a04040',
  'List-item': '#408040',
  Text: '#4a4842',
  // Core11 completions (DocLayNet / ParseBench taxonomy) — muted, in-family,
  // distinct from the neutral fallback.
  Caption: '#207868',
  Footnote: '#705848',
  Formula: '#7a2858',
};

const FALLBACK = '#8a877f';

export function pickColor(label: string | undefined): string {
  return Effect.runSync(pickColorEffect(label));
}

export function pickColorEffect(label: string | undefined): Effect.Effect<string> {
  if (!label) return Effect.succeed(FALLBACK);
  return Effect.succeed(PALETTE[label] ?? FALLBACK);
}

export function paletteKeys(): readonly string[] {
  return Object.freeze(Object.keys(PALETTE));
}
